import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";

const styles = {
  container: {
    minHeight: "76px",
    display: "flex",
    flexDirection: "column",
    '@media (min-width: 768px)': {
      flexDirection: "row",
    },
    gap: "0.5rem",
  },
  roundedContainer: {
    minHeight: "30px",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  roundedCard: {
    zIndex: 300,
    display: "flex",
    flexDirection: "row",
    margin: "5px",
    minHeight: '30px',
    background: "#ffffffa6",
    padding: "6px 20px",
    gap: "12px",
    borderRadius: "30px",
  },
  roundedIconContainer: {
    margin: "auto 0",
    borderRadius: "50%",
  },
  card: {
    zIndex: 300,
    display: "flex",
    maxWidth: '350px',
    minHeight: '30px',
    flexDirection: "row",
    margin: "5px",
    background: "#ffffffab",
    padding: "0.6rem 1.3rem",
    gap: "0.8rem",
    borderRadius: "0.5rem",
    boxShadow: '0px 1px 2px rgba(0, 0, 2, 0.04)',
  },
  textContainer: {
    margin: "auto 0",
    color: "#4c4c4c",
  },
  roundedTextContainer: {
    marginLeft: "-2px",
    margin: "auto 0",
    color: "#4c4c4c",
  },
  number: {
    //fontSize: "1rem",
    fontWeight: 800,
    color: "#4c4c4c",
  },
  iconContainer: {
    color: "#fff",
    margin: "auto 0",
    borderRadius: "9999px",
    // paddingLeft: "1rem",
  },
};

const Card = ({ icon, number, text, button, classes, component, cardStyle }) => {

  const container = cardStyle === "rounded" ? classes.roundedContainer : classes.container;
  const card = cardStyle === "rounded" ? classes.roundedCard : classes.card;
  const iconContainer = cardStyle === "rounded" ? classes.roundedIconContainer : classes.iconContainer;
  const textContainer = cardStyle === "rounded" ? classes.roundedTextContainer : classes.textContainer;

  return (
    <div className={container}>
      <div className={card}>
        {icon ? <div className={iconContainer}>{icon}</div> : null}
        <div className={textContainer}>
          <div>{text}</div>
          <div className={classes.number}>{number}</div>
          <div>{component}</div>
        </div>
        {button ? <div className={iconContainer}>{button}</div> : null}
      </div>
    </div>
  );
};

Card.propTypes = {
  icon: PropTypes.element,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  component: PropTypes.element,
  text: PropTypes.string,
  classes: PropTypes.object.isRequired,
  button: PropTypes.element,
};

export default withStyles(styles)(Card);
